module.exports = __webpack_public_path__ + "img/pricing_buy_black@2x.33fa30b1.png";